import { render, staticRenderFns } from "./CompanyProfileDetails.vue?vue&type=template&id=3d5ab406&scoped=true"
import script from "./CompanyProfileDetails.vue?vue&type=script&lang=js"
export * from "./CompanyProfileDetails.vue?vue&type=script&lang=js"
import style0 from "./CompanyProfileDetails.vue?vue&type=style&index=0&id=3d5ab406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5ab406",
  null
  
)

export default component.exports